module.exports = __webpack_public_path__ + "img/crown_gold.74225b29.svg";